<template>
  <div
    @click="closeModal"
    class="ModalPayment"
    :class="[getIsModalOpened ? 'ModalOpened' : '']"
  >
    <div class="ModalForm">
      <div class="ModalFormImage">
        <div class="ModalContainer"></div>
      </div>
      <div class="ModalFormContent">
        <div class="ModalCard">
          <div class="ModalCardPrice">
            <p>$0</p>
          </div>
          <div class="ModalContainer">
            <div class="ModalCardContent">
              <div class="ModalCardHeading">
                <h1>Sign in to unlock</h1>
                <h3>
                  Get unlimited access to all questions and answers
                </h3>
              </div>
              <div class="ModalCardList">
                <div class="ModalCardListItem">
                  <img src="../assets/img/checked.svg" alt="checked" />
                  <p>All questions</p>
                </div>
                <div class="ModalCardListItem">
                  <img src="../assets/img/checked.svg" alt="checked" />
                  <p>All answers</p>
                </div>
                <div class="ModalCardListItem">
                  <img src="../assets/img/checked.svg" alt="checked" />
                  <p>All code challenges</p>
                </div>
              </div>
              <div id="payment-form"></div>
              <div class="ModalFormButtons">
                <Loader v-if="isLoading" />
                <GoogleLoginButton
                  :isModal="true"
                  :setLoading="setLoading"
                  v-else
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Loader from './Loader';
import GoogleLoginButton from './GoogleLoginButton';

export default {
  name: 'Modal',
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    Loader,
    GoogleLoginButton,
  },
  methods: {
    ...mapActions(['updateIsModalOpened']),
    closeModal(e) {
      if (e.target.classList.contains('ModalPayment')) {
        this.updateIsModalOpened(false);
      }
    },
    setLoading(bool) {
      this.isLoading = bool;
    },
  },
  computed: {
    ...mapGetters(['getIsModalOpened', 'isSignedIn']),
  },
};
</script>

<style lang="scss" scoped>
.ModalPayment {
  display: flex;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(70, 69, 74, 0.8);
  transform: scale(0);

  &.ModalOpened {
    transform: scale(1);

    .ModalForm {
      animation: fadeIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
      animation: scaleUp 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
    }
  }

  .ModalForm {
    display: flex;
    width: 620px;
    height: 480px;
    background: $color-white;
    border-radius: 20px;
    position: relative;
    margin-bottom: 10%;
    .ModalContainer {
      padding: 0;
      height: 100%;
      border-radius: 0 20px 20px 0;
      background-color: $color-background-dark;
    }
  }
}

.ModalFormImage {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  border-radius: 20px 0 0 20px;
  background-color: lightgray;
  background: url('../assets/img/modal_bg.png') no-repeat top center;
  .ModalFormTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    h1 {
      margin-bottom: 15px;
      font-weight: 700;
      font-size: 36px;
      color: $color-white;
    }
    h3 {
      width: 340px;
      font-weight: 400;
      font-size: 18px;
      line-height: 1.5;
      color: $color-white;
    }
  }
}

.ModalFormContent {
  height: 100%;
  width: 55%;
}

.ModalCard {
  height: 100%;
  position: relative;
  .ModalCardContent {
    position: relative;
    top: 140px;
    padding: 0 25px;
  }
  .ModalCardPrice {
    position: absolute;
    top: 0;
    right: 0;
    padding: 25px;
    background: $color-purple;
    border-radius: 50px 20px 0 50px;
    p {
      font-size: 36px;
      font-weight: 600;
      color: $color-white;
    }
  }
  .ModalCardHeading {
    h1 {
      font-size: 20px;
      color: $color-purple;
      font-weight: 600;
      margin-bottom: 15px;
    }
    h3 {
      font-size: 16px;
      color: $color-white;
      font-weight: 400;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #c0bfc3;
    }
  }
}

.ModalCardList {
  margin-bottom: 50px;
  .ModalCardListItem {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    p {
      color: $color-white;
    }
    img {
      margin-right: 8px;
    }
  }
}

.ModalFormButtons {
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes fadeIn {
  0% {
    background: rgba(0, 0, 0, 0);
  }

  100% {
    background: rgba(0, 0, 0, 0.7);
  }
}

@keyframes scaleUp {
  0% {
    transform: scale(0.8) translateY(1000px);
    opacity: 0;
  }

  100% {
    transform: scale(1) translateY(0px);
    opacity: 1;
  }
}

@media screen and (max-width: 650px) {
  .ModalPayment {
    .ModalForm {
      width: 90%;
      max-height: 80%;
      margin-bottom: 15%;
      box-sizing: border-box;
      .ModalFormImage {
        display: none;
      }
      .ModalFormContent {
        width: 100%;
      }
      .ModalContainer {
        padding: 0 10px;
        border-radius: 20px;
        .ModalFormTitle {
          h1 {
            font-size: 20px;
            width: 90%;
          }
          h3 {
            font-size: 16px;
            width: 90%;
          }
        }
      }
      .ModalCardList {
        margin-bottom: 40px;
      }
    }
  }
}
</style>
